// @flow
import { all, fork, put, takeLatest, call } from 'redux-saga/effects';

import { orderResponseToOrderObject } from '../../helpers/mappers/order';

import {
    getAllOrders as getAllOrdersApi,
    createLabelForOrder as createLabelForOrderApi,
    requestOrderRefund as requestOrderRefundApi,
    getOrdersReport as getOrdersReportApi,
} from '../../helpers/';

import { ordersApiResponseSuccess, ordersApiResponseError } from './actions';
import { OrdersActionTypes } from './constants';
import { addToast } from '../actions';
import { paginationHeadersResponse } from '../../helpers/mappers/pagination';

function* ordersGetAllOrders({ payload: { returnLabel, fullResponse, query } }) {
    try {
        const getAllOrdersResponse = yield call(getAllOrdersApi, returnLabel, fullResponse, query);
        const orders = getAllOrdersResponse.data.map((orderResponse) => orderResponseToOrderObject(orderResponse));
        const pagination = { ...paginationHeadersResponse(getAllOrdersResponse.headers), ...query };
        yield put(ordersApiResponseSuccess(OrdersActionTypes.GET_ALL_ORDERS, { orders, pagination }));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(ordersApiResponseError(OrdersActionTypes.GET_ALL_ORDERS, error));
    }
}

function* ordersCreateLabelForOrder({ payload: { orderId, fullResponse } }) {
    try {
        const createLabelForOrderResponse = yield call(
            createLabelForOrderApi,
            orderId,
            /* this param does nothing */ true,
            fullResponse
        );
        yield put(ordersApiResponseSuccess(OrdersActionTypes.CREATE_LABEL_FOR_ORDER, createLabelForOrderResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(ordersApiResponseError(OrdersActionTypes.CREATE_LABEL_FOR_ORDER, error));
    }
}

function* ordersRequestOrderRefund({ payload: { orderId } }) {
    try {
        yield call(requestOrderRefundApi, orderId);
        yield put(ordersApiResponseSuccess(OrdersActionTypes.REQUEST_ORDER_REFUND, { orderId }));
        yield put(addToast({ desc: 'Order cancelled successfully', type: 'success' }));
    } catch (error) {
        yield put(addToast({ desc: error.errors?.[0]?.message || 'Unable to cancel order', type: 'error' }));
        yield put(ordersApiResponseError(OrdersActionTypes.REQUEST_ORDER_REFUND, error));
    }
}

function* ordersGetAllOrdersReport({ payload: { query } }) {
    try {
        const ordersReportResponse = yield call(getOrdersReportApi, query);
        yield put(ordersApiResponseSuccess(OrdersActionTypes.GET_ALL_ORDERS_REPORT, ordersReportResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors?.[0]?.message || 'Unable to download report', type: 'error' }));
        yield put(ordersApiResponseError(OrdersActionTypes.GET_ALL_ORDERS_REPORT, error));
    }
}

export function* watchOrdersGetAllOrders(): any {
    yield takeLatest(OrdersActionTypes.GET_ALL_ORDERS, ordersGetAllOrders);
}

export function* watchOrdersCreateLabelForOrder(): any {
    yield takeLatest(OrdersActionTypes.CREATE_LABEL_FOR_ORDER, ordersCreateLabelForOrder);
}

export function* watchOrdersRequestOrderRefund(): any {
    yield takeLatest(OrdersActionTypes.REQUEST_ORDER_REFUND, ordersRequestOrderRefund);
}

export function* watchOrdersGetAllOrdersReport(): any {
    yield takeLatest(OrdersActionTypes.GET_ALL_ORDERS_REPORT, ordersGetAllOrdersReport);
}

function* ordersSaga(): any {
    yield all([
        fork(watchOrdersGetAllOrders),
        fork(watchOrdersCreateLabelForOrder),
        fork(watchOrdersRequestOrderRefund),
        fork(watchOrdersGetAllOrdersReport),
    ]);
}

export default ordersSaga;
